import React from "react";
import { Footer } from "@gonoodle/gn-universe-ui";
import PropTypes from "prop-types";
import Head from "next/head";

import { Link, ExternalLink } from "../containers";
import AppBar from "./AppBar";

const Layout = ({
  children,
  pageTitle,
  pageDescription,
  bgColor,
  footer,
  header,
}) => (
  <>
    <Head>
      <meta
        name="description"
        content={
          pageDescription ||
          "Get Your Kids Moving & Practicing Mindfulness with GoNoodle®. Start Watching Now & Get Access to Hundreds of Videos! Active Learning. Healthy Kids. Active Kids. Boost Learning."
        }
      />

      <title>GoNoodle{pageTitle ? ` | ${pageTitle}` : ""}</title>
    </Head>
    <div className="gn-page">
      {header ? <AppBar /> : null}
      <main role="main" className={`${bgColor} gn-main`}>
        <h1 className="sr-only">{pageTitle} Page</h1>
        {children}
      </main>
      {footer ? (
        <Footer role="contentinfo" Link={Link} ExternalLink={ExternalLink} />
      ) : null}
    </div>
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitle: PropTypes.string.isRequired,
  pageDescription: PropTypes.string.isRequired,
  bgColor: PropTypes.string,
  footer: PropTypes.bool,
  header: PropTypes.bool,
};

Layout.defaultProps = {
  bgColor: "bg-gray-900",
  footer: true,
  header: true,
};

export default Layout;
